<select class="form-control" [(ngModel)]="selectedValue">
    <option value=""></option>
    <option *ngFor="let value of allValues; trackBy: trackByIndex" [value]="value">{{ value }}
    </option>
</select>